import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';

/** Unknown timeline content reserves the compact bubble and activity shapes. */
export const TimelineItemListSkeleton: React.FC = () => (
  <div
    className="flex flex-1 flex-col gap-3 overflow-hidden px-3 sm:px-5 py-3"
    aria-label="Cargando historial"
  >
    <TextSkeleton className="h-6 w-24 rounded-full mx-auto" />
    <div className="mr-auto w-2/3 space-y-2 rounded-xl bg-white p-3">
      <TextSkeleton className="h-3 w-20" />
      <TextSkeleton className="h-4 w-full" />
      <TextSkeleton className="h-4 w-3/4" />
    </div>
    <div className="ml-auto w-1/2 space-y-2 rounded-xl bg-success-50 p-3">
      <TextSkeleton className="h-4 w-full" />
      <TextSkeleton className="h-3 w-10 ml-auto" />
    </div>
    <TextSkeleton className="h-4 w-2/3 mx-auto my-1" />
    <div className="mr-auto w-3/5 space-y-2 rounded-xl bg-white p-3">
      <TextSkeleton className="h-3 w-20" />
      <TextSkeleton className="h-4 w-full" />
    </div>
  </div>
);
